import React from "react";
import styles from "./CardMetrica.module.scss";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { IMetricas } from "shared/interfaces/IMetricas";

const CardMetrica: React.FC<IMetricas> = ({
  titulo,
  valor,
  periodo,
  variacao,
  descricao,
  icon: Icon,
  color = "blue", // 👈 NOVO (default)
}) => {
  const isPositive = variacao && variacao >= 0;

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        
        {/* 🔷 ICON COM BACKGROUND */}
        {Icon && (
          <div className={`${styles.iconBox} ${styles[color]}`}>
            <Icon size={18} />
          </div>
        )}

        {variacao !== undefined && (
          <div
            className={`${styles.variacao} ${
              isPositive ? styles.up : styles.down
            }`}
          >
            {isPositive ? <ArrowUpRight size={16} /> : <ArrowDownRight size={16} />}
            {isPositive ? "+" : ""}
            {variacao}
          </div>
        )}
      </div>

      <div className={styles.titulo}>{titulo}</div>
      <div className={styles.valor}>{valor}</div>

      {periodo && <div className={styles.periodo}>{periodo}</div>}
      {descricao && <div className={styles.descricao}>{descricao}</div>}
    </div>
  );
};

export default CardMetrica;